export var ContextGLMipFilter;
(function (ContextGLMipFilter) {
    ContextGLMipFilter[ContextGLMipFilter["MIPLINEAR"] = 0] = "MIPLINEAR";
    ContextGLMipFilter[ContextGLMipFilter["MIPNEAREST"] = 1] = "MIPNEAREST";
    ContextGLMipFilter[ContextGLMipFilter["MIPNONE"] = 2] = "MIPNONE";
})(ContextGLMipFilter || (ContextGLMipFilter = {}));
